gsap.registerPlugin(ScrollTrigger);
// ==================================================================================== SECTION 1
gsap.set('.co-pdp-page-target', { opacity: 0, transition: 0 });
let coWholesaleSec1Tl = gsap.timeline();
coWholesaleSec1Tl.to('.co-pdp-page-target', {
  opacity: 1,
  duration: 1,
  ease: "power2.inOut"
});
// ==================================================================================== SECTION 2
// MARQUEE
(function () {
let tickerSpeed = 1;
let flickity = null;
let isPaused = false;
const slideshowEl = document.querySelector('.main-carousel-marquee');
const update = () => {
  if (isPaused) return;
  if (flickity.slides) {
    flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
    flickity.selectedIndex = flickity.dragEndRestingSelect();
    flickity.updateSelectedSlide();
    flickity.settle(flickity.x);
  }
  window.requestAnimationFrame(update);
};
const pause = () => {
  isPaused = true;
};
const play = () => {
  if (isPaused) {
    isPaused = false;
    window.requestAnimationFrame(update);
  }
};
flickity = new Flickity(slideshowEl, {
  autoPlay: false,
  prevNextButtons: false,
  pageDots: false,
  draggable: true,
  wrapAround: true,
  selectedAttraction: 0.015,
  friction: 0.25,
  on: {
  ready: function() {
    
      gsap.set('.co-pdp-section-2-frame', { opacity: 0, transition: 0 });
      gsap.to('.co-pdp-section-2-frame', {
        scrollTrigger: {
          trigger: '.co-pdp-section-2-frame', 
          start:'top bottom', 
          end: "bottom top",
        },
        duration: 1,
        opacity: 1
      });
    
    }
  }
});
flickity.x = 0;
slideshowEl.addEventListener('mouseenter', pause, false);
slideshowEl.addEventListener('focusin', pause, false);
slideshowEl.addEventListener('mouseleave', play, false);
slideshowEl.addEventListener('focusout', play, false);
flickity.on('dragStart', () => {
  isPaused = true;
});
update();
})();
// ==================================================================================== SECTION 3
new Flickity( '.co-pdp-section-3-carousel', {
    prevNextButtons: false, 
    pageDots: false, 
    wrapAround: true,
    contain: true,
    autoPlay: true,
    on: {
      ready: function() {
        
        gsap.set('.co-pdp-section-3-frame', { opacity: 0, transition: 0 });
        let coProductSec3Tl = gsap.timeline({ paused: false });
        ScrollTrigger.create({
          trigger:'.co-pdp-section-3-frame', 
          start:'15% bottom', 
          end: "bottom top",
          toggleActions: "play none none reverse",
          animation: coProductSec3Tl
        });
        coProductSec3Tl.to('.co-pdp-section-3-frame', {
            duration: 1,
            opacity: 1,
            ease: "power2.inOut"
        });
        
      }
    }
  });
// ==================================================================================== SECTION 4
gsap.set('.co-pdp-section-4 .collapsible-content', { opacity: 0, transition: 0 });
let coProductSec4Tl = gsap.timeline({ paused: false });
ScrollTrigger.create({
  trigger:'.co-pdp-section-4', 
  start:'15% bottom', 
  end: "bottom top",
  toggleActions: "play none none reverse",
  animation: coProductSec4Tl
});
coProductSec4Tl.to('.co-pdp-section-4 .collapsible-content', {
    duration: 1,
    opacity: 1,
    ease: "power2.inOut"
});